<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagementlog}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
       <el-form-item label="">
          <wPickers v-model="dateValue" @input="getTimes"></wPickers>
        </el-form-item>
        <el-form-item>
          <wList
            v-model="dataForm.trafficPlatform"
            dataUrl="/sys/channels/list"
            placeholder="平台"
          ></wList>
        </el-form-item>
        
        <el-form-item>
          <renSelect
            v-model="dataForm.product"
            dictType="loan_type"
            originPage="put"
            placeholder="产品"
          ></renSelect>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
            <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagementlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagementlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item> -->
      </el-form>
      <div class="msgbox">
       <span>TIPS</span>：若投放线索数量为>0,成本单价为0，请联系运营录入消耗。
      </div>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @sort-change="dataListSortChangeHandle($event,false)"
      >
        <el-table-column
          prop="reportDate"
          label="日期"
          header-align="center"
          align="center"
          sortable="custom"
        >
        <template slot-scope="scope">
          <div>
            {{scope.row.reportDate.split(' ')[0]}}
          </div>
        </template>
      </el-table-column>
        <el-table-column
          prop="trafficPlatformName"
          label="媒体平台"
          header-align="center"
          align="center"
         
        ></el-table-column>
        <el-table-column
          prop="productName"
          label="产品"
          header-align="center"
          align="center"
         
        ></el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="deliverLeads"
          label="投放线索数量"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="productPrice"
          label="定价"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="costPrice"
          label="成本单价"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="retentionRate"
          label="留存率"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
  </el-card>
</template>
  
  <script>
import mixinViewModule from "@/mixins/view-module";

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/deliveryreport/page",
        getDataListIsPage: true,
        exportURL: "/sys/deliveryreport/export",
        deleteURL: "/sys/deliveryreport",
        deleteIsBatch: true,
      },
      dateValue: "",
      dataForm: {
        id: "",
        product: "",
        startDate: "",
        endDate: "",
        trafficPlatform: '',
      },
    };
  },
  mounted() {
   
  },
  methods: {
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0];
        this.dataForm.endDate = this.dateValue[1];
      } else {
        delete this.dataForm.startDate 
        delete this.dataForm.endDate
      }
    },
  
  },
  components: {},
};
</script>
  
  <style scoped lang="scss">

.msgbox {
  padding: 2px 10px;
  font-weight: 400;
  font-style: normal;
  color: #d9001b;
  text-align: center;
  background: #f5debc;
  width: 500px;
  font-size: 16px;
  & :nth-child(1) {
    font-weight: 900;
  }
}
</style>